export const URL_API_LOGIN_PATH1 = '/users/validate';
export const URL_API_LOGIN_PATH2 = '/users/confirm';

export const URL_API_HOME_PATH = '/home';

export const URL_API_USER_RESIDENCE = '/users/locations';
export const URL_API_CANJE = '/users/redeem';
export const URL_API_CANJE_CONFIRM = '/users/confirm-redeem';
export const URL_API_CANJE_CANCEL = '/users/cancel-redeem';

export const URL_API_PRODUCTO = '/product/';
export const URL_API_PRODUCTO_RUBRO = '/product/category/';
export const URL_API_PRODUCTO_BUSQUEDA = '/product/criteria?Key=';

export const URL_API_RUBRO_LIST = '/category';
